import React from 'react'
import { Modal } from 'antd'
import { useFFEStore } from '../../store/ffeStore'
import { ImageEditor } from './ImageEditor'

export const ImageLightbox: React.FC = () => {
  const imageEditorEntity = useFFEStore((state) => state.imageEditorEntity)
  const setImageEditorEntity = useFFEStore(
    (state) => state.setImageEditorEntity
  )
  return (
    <Modal
      open={!!imageEditorEntity}
      footer={null}
      onCancel={() => setImageEditorEntity(undefined)}
      centered
      className="image-lightbox min-w-[60vw] max-w-[70vw]"
      width="60vw"
      closeIcon={null}
      styles={{
        body: {
          padding: 0,
          backgroundColor: '#000',
          borderRadius: '8px'
        },
        mask: {
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(0, 0, 0, 0.8)'
        }
      }}
    >
      {!!imageEditorEntity && <ImageEditor />}
    </Modal>
  )
}
